import DeviceDetector from 'device-detector-js';

/**
 * Best-effort device label from User-Agent for passkey nickname prefills.
 * Coarse and spoofable — always keep the field editable.
 */
export function suggestedPasskeyNickname() {
  if (typeof window === 'undefined' || !window.navigator?.userAgent) {
    return '';
  }

  try {
    const parsed = new DeviceDetector().parse(window.navigator.userAgent);
    const label = deviceLabel(parsed);
    if (!label) return '';
    return label.startsWith('My ') ? label : `My ${label}`;
  } catch {
    return '';
  }
}

function deviceLabel(parsed) {
  if (!parsed) return '';

  const model = (parsed.device?.model || '').trim();
  if (model) return model;

  const brand = (parsed.device?.brand || '').trim();
  const type = (parsed.device?.type || '').toLowerCase();
  const osName = (parsed.os?.name || '').trim();

  if (type === 'smartphone' || type === 'phablet') {
    if (osName === 'iOS') return 'iPhone';
    if (osName === 'Android') return brand ? `${brand} phone` : 'Android phone';
    return brand ? `${brand} phone` : 'phone';
  }

  if (type === 'tablet') {
    if (osName === 'iOS' || brand === 'Apple') return 'iPad';
    if (osName === 'Android') return brand ? `${brand} tablet` : 'Android tablet';
    return brand ? `${brand} tablet` : 'tablet';
  }

  if (osName === 'Mac' || osName === 'Mac OS X') return 'Mac';
  if (osName === 'Windows') return 'Windows PC';
  if (osName === 'Chrome OS') return 'Chromebook';
  if (osName === 'Linux') return 'Linux PC';
  if (osName === 'Ubuntu') return 'Linux PC';

  if (type === 'desktop' && brand) return `${brand} computer`;
  if (type === 'desktop') return 'computer';

  return osName || brand || '';
}
